import React, { Component } from "react";
import Highcharts from "highcharts";
import { components } from 'react-select'
import HighchartsReact from "highcharts-react-official";
import { Row, Col, Container, Form, Button, Card } from 'react-bootstrap';
import SelectDropDown from "../../../neetjee_guru/components/selectdropdown/SelectDropDown";
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as compose from 'lodash.flowright';
import { withRouter } from "react-router-dom";
import * as Cookies from "es-cookie";
import PreloaderTwo from "../preloader/PreloaderTwo";
import DateBlock from "../../../neetjee_guru/components/home/DateBlock";
import CardLessDataTableWithSearch from "../data_tables/CardLessDataTableWithSearch";
import './_studentPerformanceReport.scss';



const DropdownIndicator = (props) => {
    return (
        components.DropdownIndicator && (
            <components.DropdownIndicator {...props}>
                <svg height="20" width="20" viewBox="0 0 20 20" aria-hidden="true" focusable="false" className="css-6q0nyr-Svg"><path fill="currentColor" d="M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"></path></svg>
            </components.DropdownIndicator>
        )
    );
};

const FETCH_STUDENTDATA_REPORT = gql` 
query($student_user_exam_id: Int!,$type:Int,$weekday:Int,$fromDate:String,$toDate:String) {
    getStudentDataCombined(student_user_exam_id: $student_user_exam_id,type:$type,weekday:$weekday,fromDate:$fromDate,toDate:$toDate){
       overall {
      id
      correct
      wrong
      not_answered
      total_questions
      correct_marks
      negative_marks
      total_marks
      total_time
      exam_rank
      state_rank
      city_rank
      branch_rank
      section_rank
    }
       accuracy {
      attempted
      not_answered
      correct
      wrong
      correct_percentage
      error_percentage
    }
         complexity {
      easy {
        not_answered
        correct
        wrong
      }
      moderate {
        not_answered
        correct
        wrong
      }
      difficult {
        not_answered
        correct
        wrong
      }
      highlyDifficult {
        not_answered
        correct
        wrong
      }
    }
        subjects {
      subject
      subject_id
      chapters {
        chapter
        chapter_id
        accuracy
      }
    }
   }
}
`;


class StudentPerformanceCharts extends Component {
    constructor(props) {
        super(props)
        this.state = {
            selectSubject: { value: 0, label: 'Select Subject' },
            selectedViews: {
                overall: 1,
                accuracy: 1,
                difficulty: 1,
                examResult: 1,
                chapterPerformance: 1,
            }
        }
    };

    componentDidMount() {
        this.setState({
            selectSubject: {
                value: 0,
                label: "Select Subject"
            }
        });
    };


    handleViewChange = (key, value) => {
        this.setState(prev => ({
            selectedViews: {
                ...prev.selectedViews,
                [key]: value
            }
        }));
    };

    selecthandleInputChange = (ename, evalue) => {
        if (ename === "selectSubject") {
            const subjectData = this.props.getSubjects.find(
                (a) => +a.id === +evalue
            );

            if (subjectData) {
                this.setState({
                    selectSubject: {
                        value: subjectData.id,
                        label: subjectData.subject
                    }
                });
            }
        } else {
            this.setState({
                selectSubject: {
                    value: 0,
                    label: "Select Subject"
                }
            });
        }
    };

    renderReportCard = (title, tableData, columns, graphOptions, key) => {
        const { selectedViews } = this.state;
        return (
            <Card className="shadow-sm w-100"
                style={{ borderRadius: "12px", height: "100%" }}>

                <Card.Header
                    className="d-flex justify-content-between align-items-center"
                    style={{ background: "#fff" }}
                >
                    <h6 className="mb-0">{title}</h6>

                    {/* RIGHT SIDE BUTTONS */}
                    <div className="btn-group">
                        {[
                            { value: 1, label: "Graph", icon: "fas fa-chart-bar" },
                            { value: 2, label: "Table", icon: "fas fa-table" }
                        ].map(btn => (
                            <Button
                                key={btn.value}
                                className={
                                    selectedViews[key] === btn.value
                                        ? "view-btn active-view-btn"
                                        : "view-btn"
                                }
                                onClick={() => this.handleViewChange(key, btn.value)}
                            >
                                <i className={btn.icon}></i>&nbsp;&nbsp;{btn.label}
                            </Button>
                        ))}
                    </div>

                </Card.Header>

                {/* BODY */}
                <Card.Body>

                    {/* GRAPH VIEW */}
                    {selectedViews[key] === 1 && (
                        tableData?.length > 0 ? (
                            <>
                                <HighchartsReact highcharts={Highcharts} options={graphOptions} />
                            </>
                        ) : (
                            <div className="text-center text-danger">
                                No Data Found
                            </div>
                        )
                    )}


                    {selectedViews[key] === 2 && (
                        tableData?.length > 0 ? (
                            <>
                                <CardLessDataTableWithSearch
                                    parentData={tableData}
                                    particlecolumns={columns}
                                    name="report"
                                />
                            </>
                        ) : (
                            <div className="text-center text-danger">
                                No Data Found
                            </div>
                        )
                    )}

                </Card.Body>
            </Card>
        );
    };

    render() {
        const getStudentDataCombined = this.props.getStudentDataCombined;
        const loading1 = getStudentDataCombined.loading;
        const error1 = getStudentDataCombined.error;

        if (loading1) return <PreloaderTwo />;
        if (error1 !== undefined) {
            alert("Server Error. " + error1.message);
            return null;
        }

        const reportData = getStudentDataCombined.getStudentDataCombined;

        const overallGraph = {
            chart: {
                type: "column",
                backgroundColor: "#f5f7fa",
                borderRadius: 10,
                spacingLeft: 20,
                scrollablePlotArea: {
                    minWidth: reportData?.overall?.length > 10 ? reportData?.overall?.length * 80 : null,
                    scrollPositionX: 0
                }
            },
            title: {
                text: ""
            },
            xAxis: {
                categories: reportData?.overall?.map((item) => item.timestamp),
                labels: {
                    // rotation: -45,
                    style: {
                        fontWeight: "600"
                    }
                }
            },

            yAxis: [
                {
                    title: {
                        text: "Marks / Accuracy"
                    }
                },
                {
                    title: {
                        text: "Ranks"
                    },
                    opposite: true,
                    reversed: false
                }
            ],

            credits: { enabled: false },

            plotOptions: {
                column: {
                    grouping: true,
                    borderRadius: 5,
                    dataLabels: {
                        enabled: true,
                        style: {
                            fontSize: "9px"
                        }
                    }
                }
            },
            series: [
                {
                    name: "Overall Score",
                    data: reportData?.overall?.map(item => item.total_marks),
                    color: "#1f4e79" // dark blue
                },
                {
                    name: "Exam Rank",
                    data: reportData?.overall?.map(item => Number(item.exam_rank)),
                    color: "#8b5cf6" // purple
                },
                {
                    name: "State Rank",
                    data: reportData?.overall?.map(item => Number(item.state_rank)),
                    color: "#f59e0b" // orange
                },
                {
                    name: "City Rank",
                    data: reportData?.overall?.map(item => Number(item.city_rank)),
                    color: "#06b6d4" // cyan
                },
                {
                    name: "Branch Rank",
                    data: reportData?.overall?.map(item => Number(item.branch_rank)),
                    color: "#10b981" // green
                },
                {
                    name: "Section Rank",
                    data: reportData?.overall?.map(item => Number(item.section_rank)),
                    color: "#ef4444" // red
                }
            ],
            exporting: {
                enabled: true
            },

            credits: {
                enabled: false
            }
        };

        const accuracyGraph = {
            chart: {
                type: "pie",
                backgroundColor: "#f5f7fa",
                borderRadius: 10
            },
            title: {
                text: null
            },
            tooltip: {
                shared: true
            },
            credits: {
                enabled: false   // ✅ removes Highcharts.com
            },
            exporting: {
                enabled: true
            },

            credits: {
                enabled: false
            },
            series: [
                {
                    name: "Share",
                    data: [
                        { name: "Correct", y: reportData?.accuracy?.correct, color: "#2ca02c" },
                        { name: "Wrong (Negative Marks)", y: reportData?.accuracy?.wrong, color: "#ff0033" },
                        { name: "Unattempted", y: reportData?.accuracy?.not_answered, color: "#C2C2C2" },
                    ]
                }
            ],
            // Optional: Add data labels configuration
            plotOptions: {
                pie: {
                    dataLabels: {
                        enabled: true,
                        format: '<b>{point.name}</b>: {point.y:f}' // Format for data labels.
                    }
                }
            }
        };

        const difficultyGraph = {
            chart: {
                type: "column",
                backgroundColor: "#f5f7fa",
                borderRadius: 10
            },
            title: {
                text: null
            },
            xAxis: {
                categories: ["Easy", "Moderate", "Difficult", "Highly Difficult"]
            },
            yAxis: {
                min: 0,
                title: {
                    text: "Questions Count"
                }
            },
            tooltip: {
                headerFormat: "<b>{point.x}</b><br/>",
                pointFormat: "{series.name}: {point.y}<br/>Total: {point.stackTotal}"
            },
            legend: {
                enabled: true
            },
            credits: {
                enabled: false
            },
            plotOptions: {
                column: {
                    stacking: "normal",
                    dataLabels: {
                        enabled: true,
                        style: {
                            textOutline: "none"
                        }
                    }
                }
            },
            series: [
                {
                    name: "Correct",
                    data: [
                        reportData?.complexity?.easy.correct,
                        reportData?.complexity?.moderate.correct,
                        reportData?.complexity?.difficult.correct,
                        reportData?.complexity?.highlyDifficult.correct
                    ],
                    color: "#28a745"
                },
                {
                    name: "Wrong",
                    data: [
                        reportData?.complexity?.easy.wrong,
                        reportData?.complexity?.moderate.wrong,
                        reportData?.complexity?.difficult.wrong,
                        reportData?.complexity?.highlyDifficult.wrong
                    ],
                    color: "#e6194B"
                },
                {
                    name: "Not Answered",
                    data: [
                        reportData?.complexity?.easy.not_answered,
                        reportData?.complexity?.moderate.not_answered,
                        reportData?.complexity?.difficult.not_answered,
                        reportData?.complexity?.highlyDifficult.not_answered
                    ],
                    color: "#6c757d"
                }
                ,
                {
                    name: "High Difficult",
                    data: [
                        reportData?.complexity?.easy.not_answered,
                        reportData?.complexity?.moderate.not_answered,
                        reportData?.complexity?.difficult.not_answered,
                        reportData?.complexity?.highlyDifficult.not_answered
                    ],
                    color: "#F98866"
                }
            ]
        };

        const selectedSubject = reportData?.subjects?.find(
            (item) => +item.subject_id === +this.state.selectSubject?.value
        );

        const chapters = selectedSubject?.chapters || [];

        const chapterSeriesData = chapters.map((chapter) => ({
            name: chapter.chapter,
            y: Number(chapter.accuracy || 0)
        }));

        const chapterGraph = {
            chart: {
                type: "column"
            },
            title: {
                text: ""
            },
            xAxis: {
                type: "category"   // ✅ IMPORTANT (not 'chapter')
            },
            yAxis: {
                title: {
                    text: "Accuracy (%)"
                }
            },
            legend: {
                enabled: false
            },
            legend: {
                enabled: true
            },
            credits: {
                enabled: false
            },
            plotOptions: {
                series: {
                    borderWidth: 0,
                    dataLabels: {
                        enabled: true,
                        format: "{point.y:.1f}%"
                    }
                }
            },
            series: [
                {
                    name: "Accuracy",
                    colorByPoint: true,
                    data: chapterSeriesData
                }
            ]
        };


        return (
            <Container fluid>
                <Form className="d-flex justify-content-end" as={Row}>
                    {
                        [
                            { id: 1, value: this.props.stateData.selectExamType, name: "selectExamType", options: this.props.stateData.examTypes, placeholder: "Select Exam Type" },
                            { id: 2, },
                        ].map((item, index) => (
                            <Col xl={3} lg={3} md={3} sm={12} className="mt-3" key={index}>
                                {
                                    item.id === 2 ? (
                                        <DateBlock applyCallback={this.props.applyCallback}
                                            stateData={this.props.stateData}
                                        />
                                    ) : (
                                        <SelectDropDown
                                            stateData={item.value}
                                            handleChange={this.props.handleChange}
                                            name={item.name}
                                            options={item.options}
                                            placeholderName={item.placeholder}
                                            dropdownIndicator={{ DropdownIndicator }}
                                        />
                                    )
                                }
                            </Col>
                        ))
                    }
                </Form>


                <Row className="mt-5">
                    <Col sm={12} className="mt-1">
                        {this.renderReportCard(
                            "Overall Performance",
                            reportData?.overall,
                            [
                                {
                                    dataField: "index",
                                    text: "#",
                                    formatter: (cell, row, rowIndex) => rowIndex + 1,
                                },
                                {
                                    dataField: "timestamp",
                                    text: "Date",
                                    sort: true,
                                    align: "center",
                                    headerClasses: "text-center",
                                },
                                {
                                    dataField: "attempted",
                                    text: "Attempted",
                                    sort: true,
                                    align: "center",
                                },
                                {
                                    dataField: "correct",
                                    text: "Correct",
                                    sort: true,
                                    align: "center",
                                },
                                {
                                    dataField: "wrong",
                                    text: "Wrong",
                                    sort: true,
                                    align: "center",
                                },
                                {
                                    dataField: "not_answered",
                                    text: "Not Answered",
                                    sort: true,
                                    align: "center",
                                },
                                {
                                    dataField: "total_questions",
                                    text: "Total Questions",
                                    sort: true,
                                    align: "center",
                                },
                                {
                                    dataField: "correct_marks",
                                    text: "Correct Marks",
                                    sort: true,
                                    align: "center",
                                },
                                {
                                    dataField: "negative_marks",
                                    text: "Negative Marks",
                                    sort: true,
                                    align: "center",
                                },
                                {
                                    dataField: "total_marks",
                                    text: "Total Marks",
                                    sort: true,
                                    align: "center",
                                },
                                {
                                    dataField: "total_time",
                                    text: "Time (sec)",
                                    sort: true,
                                    align: "center",
                                },
                                // 🔥 RANKS
                                {
                                    dataField: "exam_rank",
                                    text: "Exam Rank",
                                    sort: true,
                                    align: "center",
                                },
                                {
                                    dataField: "state_rank",
                                    text: "State Rank",
                                    sort: true,
                                    align: "center",
                                },
                                {
                                    dataField: "city_rank",
                                    text: "City Rank",
                                    sort: true,
                                    align: "center",
                                },
                                {
                                    dataField: "branch_rank",
                                    text: "Branch Rank",
                                    sort: true,
                                    align: "center",
                                },
                                {
                                    dataField: "section_rank",
                                    text: "Section Rank",
                                    sort: true,
                                    align: "center",
                                }
                            ],
                            overallGraph,
                            "overall"
                        )}
                    </Col>

                    <Col sm={6} className="mt-4">
                        {this.renderReportCard(
                            "Accuracy Analysis",
                            [reportData?.accuracy],
                            [
                                {
                                    dataField: "index",
                                    text: "#",
                                    formatter: (cell, row, rowIndex) => rowIndex + 1,
                                },
                                {
                                    dataField: "correct",
                                    text: "Correct",
                                    sort: true,
                                    align: 'center',
                                    headerClasses: 'text-center',
                                },
                                {
                                    dataField: "wrong",
                                    text: "Wrong",
                                    sort: true,
                                    align: 'center',
                                    headerClasses: 'text-center',
                                },
                                {
                                    dataField: "not_answered",
                                    text: "Not Answered",
                                    sort: true,
                                    align: 'center',
                                    headerClasses: 'text-center',
                                },
                            ],
                            accuracyGraph,
                            "accuracy"
                        )}
                    </Col>

                    <Col sm={6} className="mt-4">
                        {this.renderReportCard(
                            "Difficulty Split",
                            [
                                {
                                    level: "Easy",
                                    ...reportData?.complexity?.easy
                                },
                                {
                                    level: "Moderate",
                                    ...reportData?.complexity?.moderate
                                },
                                {
                                    level: "Difficult",
                                    ...reportData?.complexity?.difficult
                                },
                                {
                                    level: "Highly Difficult",
                                    ...reportData?.complexity?.highlyDifficult
                                }
                            ],
                            [
                                {
                                    dataField: "index",
                                    text: "#",
                                    formatter: (cell, row, rowIndex) => rowIndex + 1,
                                },
                                {
                                    dataField: "level",
                                    text: "Level",
                                    sort: true,
                                    align: 'center',
                                    headerClasses: 'text-center',
                                },
                                {
                                    dataField: "correct",
                                    text: "Date",
                                    sort: true,
                                    align: 'center',
                                    headerClasses: 'text-center',
                                },
                                {
                                    dataField: "wrong",
                                    text: "Attempted",
                                    sort: true,
                                    align: 'center',
                                    headerClasses: 'text-center',
                                },

                                {
                                    dataField: "not_answered",
                                    text: "Not Answered",
                                    sort: true,
                                    align: 'center',
                                    headerClasses: 'text-center',
                                },
                            ],
                            difficultyGraph,
                            "difficulty"
                        )}
                    </Col>

                    <Col sm={12} className="mt-4">
                        {this.renderReportCard(
                            "Chapter Performance",
                            chapters,
                            [
                                {
                                    dataField: "index",
                                    text: "#",
                                    formatter: (cell, row, rowIndex) => rowIndex + 1,
                                },
                                {
                                    dataField: "chapter",
                                    text: "Chapter",
                                    sort: true,
                                    align: 'center',
                                    headerClasses: 'text-center',
                                },
                                {
                                    dataField: "accuracy",
                                    text: "Accuracy",
                                    sort: true,
                                    align: 'center',
                                    headerClasses: 'text-center',
                                },
                            ],
                            chapterGraph,
                            "chapterPerformance"
                        )}
                    </Col>
                </Row>
            </Container>
        );
    }
}

export default withRouter(
    compose(
        graphql(FETCH_STUDENTDATA_REPORT, {
            options: (props) => ({
                variables: {
                    student_user_exam_id: parseInt(Cookies.get("student_user_exam_id")),
                    type: parseInt(props.stateData?.selectExamType?.value || 0),
                    weekday: parseInt(1),
                    fromDate: Math.floor(new Date(props.stateData.startDate).getTime() / 1000).toString(),
                    toDate: Math.floor(new Date(props.stateData.endDate).getTime() / 1000).toString()
                },
                fetchPolicy: "network-only"
            }),
            name: "getStudentDataCombined"
        })
    )(StudentPerformanceCharts)
);